// Generated by CoffeeScript 2.7.0
var GenerateTagGroupsSidebar;

import EditTagGroupModal from 'trunks/vue/admin/compositions/tags_groups/tag_group_modal/edit_tag_group_modal.js';

import TagGroupListItem from './tag_group_sidebar/tag_group_list_item.js';

import TagsTab from './tags_tab.js';

export var TagsGroupSidebar = Vue.extend({
  components: {
    'tags-tab': TagsTab,
    'tags-group-list-item': TagGroupListItem
  },
  props: {
    initialSelectedTagsGroupId: {
      type: String
    },
    defaultTab: {
      type: String
    }
  },
  data: function() {
    return {
      selectedTagsGroupId: this.initialSelectedTagsGroupId,
      tagsGroupOptions: [],
      doRequestUrl: `/admin/tag_groups/${this.defaultTab}`,
      activeTab: this.defaultTab
    };
  },
  template: `<div class="sidebar-tags" tags-has-navigator>
  <tags-tab :initialActiveTab='defaultTab'
            @tabChanged="tabChangedFunc" />
  <div class="list">
    <div class="list-head">
      <button class="text-btn btn-primary" @click="openTagGroupModalFunc">
        <i class="slp-plus-circle"></i>
        <span>新增标签分组</span>
      </button>
    </div>
    <div class="list-content" v-if='tagsGroupOptions.length'>
      <tags-group-list-item v-for='group in tagsGroupOptions'
                        :group='group'
                        :key='group.id'
                        :selectedTagsGroupId='selectedTagsGroupId'
                        @deletedTagGroup="deletedTagGroupFunc"
                        @selectedTagsGroupChange="selectedTagsGroupChangeFunc"/>
    </div>
    <div class="list-content" v-else>
      <div class="no-data">暂无成员标签分组</div>
    </div>
  </div>
</div>`,
  watch: {
    doRequestUrl: {
      handler: function() {
        return this.doRequest();
      },
      immediate: true
    },
    selectedTagsGroupId: function(val) {
      if (val) {
        return Turbolinks.visit(`/admin/tag_groups/${this.activeTab}/${this.selectedTagsGroupId}`);
      } else {
        return Turbolinks.visit(`/admin/tag_groups/${this.activeTab}`);
      }
    }
  },
  methods: {
    doRequest: function() {
      return Skylark.Libs.Ajax.get(this.doRequestUrl, {
        responseType: 'json',
        success: (data) => {
          var ref;
          this.tagsGroupOptions = data;
          return this.selectedTagsGroupId = (ref = this.tagsGroupOptions[0]) != null ? ref.id : void 0;
        }
      });
    },
    tabChangedFunc: function(activeTab) {
      this.activeTab = activeTab;
      return this.doRequestUrl = `/admin/tag_groups/${activeTab}`;
    },
    selectedTagsGroupChangeFunc: function(group) {
      return this.selectedTagsGroupId = group.id;
    },
    deletedTagGroupFunc: function(group) {
      var ref;
      this.tagsGroupOptions = _.reject(this.tagsGroupOptions, function(tag_group) {
        return tag_group.id === group.id;
      });
      if (this.selectedTagsGroupId === group.id) {
        return this.selectedTagsGroupId = (ref = this.tagsGroupOptions[0]) != null ? ref.id : void 0;
      }
    },
    openTagGroupModalFunc: function() {
      return new EditTagGroupModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('add-tag-group-modal'),
        propsData: {
          title: '新增标签分组',
          callback: (tagGroupName) => {
            return this.addTagGroupFunc(tagGroupName);
          }
        }
      });
    },
    addTagGroupFunc: function(tagGroupName) {
      return Skylark.Libs.Ajax.post(this.doRequestUrl, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: {
          tag_group: {
            name: tagGroupName
          }
        },
        success: (data) => {
          Skylark.Bridge.newAlertify('添加标签分组成功', {
            type: 'success'
          });
          data.tags = [];
          return this.tagsGroupOptions.push(data);
        }
      });
    }
  }
});

export default GenerateTagGroupsSidebar = {
  _generateTagGroupsSidebar: function(activeTab, selectedTagsGroupId) {
    var navigator_el;
    navigator_el = DomMaster.find('[tags-has-navigator]');
    return this.sidebarVm = navigator_el.isPresent() ? navigator_el.node.__vue__ : new TagsGroupSidebar({
      el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('tags_group_sidebar'),
      propsData: {
        defaultTab: activeTab,
        initialSelectedTagsGroupId: selectedTagsGroupId
      }
    });
  }
};
